module.exports = {
  arabicText: require('./arabic-text').default,
  arabicText2: require('./arabic-text2').default,
  tree: require('./tree').default,
  womanWithHorse: require('./woman-with-horse').default,
};